module.exports = __webpack_public_path__ + "HRA Postcard - Percent Based.pdf";